import context, { Constants } from '@truckdown/systems';
import { PromotionModel, PromotionStatus } from '@truckdown/promotions';
import { defineComponent, ref, Ref, onMounted } from 'vue';

import addPromotion from "../AddPromotion/AddPromotion.vue";

import { IPromotionQueryService, PromotionQueryModel } from '@truckdown/promotions';
import { isCsrOrAdmin } from "../../Utilities/utilities";

import { ILocationQueryService, FindLocationsUsingAccounts, LocationQueryOptions, Listing } from '@truckdown/locations';

interface IData {
    isLoading: Ref<boolean>,
    showNoLocations: Ref<boolean>,
    showNoPromotions: Ref<boolean>,
    showAddPromotion: Ref<boolean>,
    accountId: Ref<string>
    promotions: Ref<PromotionModel[]>,
    listings: Ref<Listing[]>,
    taxName: Ref<string>,
    taxRate: Ref<number>
};

const getInitialData = function (props: any): IData {
    return {
        isLoading: ref<boolean>(false),
        showNoLocations: ref<boolean>(false),
        showNoPromotions: ref<boolean>(false),
        showAddPromotion: ref<boolean>(false),
        accountId: ref<string>(props.accountid ?? context.user?.accountId),
        promotions: ref<PromotionModel[]>([]),
        listings: ref<Listing[]>([]),
        taxName: ref<string>(props.taxname),
        taxRate: ref<number>(props.taxrate)
    };
}

const getComputed = function (props: any) {
    return {

    };
}

const getMethods = function (props: any, data: IData) {
    return {
        toggleAddPromotionModal: function () {
            data.showAddPromotion.value = !data.showAddPromotion.value;
        },
        getListing: function (promotion: PromotionModel, listings: Listing[]) {
            if (promotion.locationIds.length > 0) {
                for (var i = 0; i < promotion.locationIds.length; i++) {
                    var id = promotion.locationIds[i];
                    for (var j = 0; j < listings.length; j++) {
                        var listing = listings[j];
                        if (listing.id === id) {
                            return listing;
                        }
                    }
                }
            }

            return listings[0];
        },
        cancelAdd: function () {
            data.showAddPromotion.value = false;
        },
        applyAdd: async function (promotion: PromotionModel) {
            data.showAddPromotion.value = false;
            await loadPromotions(props.accountid, data);
        },
        removePromo: function (promotion: PromotionModel) {
            data.promotions.value = data.promotions.value.filter(l => l.id != promotion.id);
        },
        updatePromo: function (promotion: PromotionModel) {
            var existing = data.promotions.value.filter(l => l.id == promotion.id);
            if (existing.length > 0) {
                //replace
                let idx = data.promotions.value.indexOf(existing[0]);
                data.promotions.value.splice(idx, 1, promotion);
            }
        }
    };
}

const loadPromotions = async function (accountId: string, data: IData) {
    if (!data.isLoading.value) {
        data.isLoading.value = true;
        try {
            var promotionQuery = await context.getService<IPromotionQueryService>('IPromotionQueryService');
            var response = await promotionQuery.find(
                {
                    accountId: accountId,
                    statuses: [PromotionStatus.Active, PromotionStatus.PendingApproval] as PromotionStatus[]
                } as PromotionQueryModel);

            data.promotions.value = response;

            if (data.promotions.value.length == 0) {
                data.showNoPromotions.value = true;
            } else {
                data.showNoPromotions.value = false;
            }
        }
        catch (err) {
            console.log('Error loading promotions', err);
        }
        finally {
            data.isLoading.value = false;
        }
    }
}

const getLocations = async function (data: IData) {
    try {
        let locationQueryService = await context.getService<ILocationQueryService>('ILocationQueryService');
        let options = {
            accountIds: [data.accountId.value],
            tags: ["#loc-paid", "#active"]
        } as FindLocationsUsingAccounts;

        if (isCsrOrAdmin() === true) {
            options.tags = ["#active", "||#inactive"];
        }

        var response = await locationQueryService.findListings(options);

        if (response && (response.count ?? 0) > 0) {
            data.listings.value = response.results ?? [];
            data.showNoLocations.value = false;
        } else {
            data.showNoLocations.value = true;
        }
    } catch (ex) {
        console.log(ex);
    }
}

export default defineComponent({
    name: "Dashboard",
    components: {
        'add-promotion': addPromotion
    },
    props: {
        accountid: {
            type: String,
            required: true
        },
        taxname: {
            type: String,
            required: true
        },
        taxrate: {
            type: Number,
            required: true
        }
    },
    setup: function (props) {
        let data = getInitialData(props);
        let computed = getComputed(props);
        let methods = getMethods(props, data);

        onMounted(async () => {
            await loadPromotions(props.accountid, data)
            await getLocations(data);
        });

        return {
            ...data,
            ...computed,
            ...methods,
            'isCsrOrAdmin': isCsrOrAdmin(),
            'enableEdit': context.isInRole(Constants.Roles.CustomerAdminRole) || isCsrOrAdmin()
        }
    }
});